// @flow

import { Component } from '../jsti/core';
import EventNames from '../constants/EventNames';

export default class CollapseButtonComponent extends Component {
  #clickHandler: function;
  #content: any;
  class: string = 'hidden';

  /**
   *
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.#clickHandler = this.handleClick.bind(this);

    const content: any = pEl.nextElementSibling;
    if (content) {
      this.#content = content;
    } else {
      throw new Error('Collapsible content is required to be next to the button');
    }

    this.addEventListener(EventNames.CLICK, this.#clickHandler);
  }

  /**
   *
   */
  handleClick(e: Event): void {
    e.preventDefault();
    this.#content.classList.toggle(this.class);
  }
}
